import { render, staticRenderFns } from "./EditBulkPrice.vue?vue&type=template&id=71d1a8f2&lang=pug"
import script from "./EditBulkPrice.vue?vue&type=script&lang=js"
export * from "./EditBulkPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports